import { Directive, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

import { FileUploadValidators } from '../validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'pcs-file-upload[fileSize][formControlName], pcs-file-upload[fileSize][formControl]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => FileSizeDirective),
    multi: true
  }]
})
export class FileSizeDirective implements Validator, OnChanges {
  @Input() fileSize: number;

  private validator: ValidatorFn;
  private onChange: () => void;

  ngOnChanges({fileSize}: SimpleChanges): void {
    if (fileSize) {
      this.createValidator();
      if (this.onChange) {
        this.onChange();
      }
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator?.(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  private createValidator() {
    this.validator = FileUploadValidators.fileSize(this.fileSize);
  }

}
